function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:none;}\n");

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M79.5,47.3c8.9,0,16,7.2,16,16v64.1c0,8.9-7.2,16-16,16H15.3c-8.9,0-16-7.2-16-16v-64c0-8.9,7.2-16,16-16h64.2 V47.3z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  d: "M80,48H16C7.2,48,0,55.2,0,64v64c0,8.8,7.2,16,16,16h64c8.8,0,16-7.2,16-16V64C96,55.2,88.8,48,80,48z"
}), React.createElement("path", {
  d: "M496.7,71.4H175.8c-8.8,0-16,7.1-16,16v16c0,1.8,0.3,3.6,0.9,5.3c2,6.5,8.1,11.3,15.3,11.3h320c4,0,7.6-1.5,10.4-3.9 c3.8-2.9,6.3-7.5,6.3-12.7v-16C512.7,78.6,505.6,71.4,496.7,71.4z"
}), React.createElement("path", {
  d: "M456.8,233.4c-15.5-0.3-30.2,5.4-41.3,16.3c-11.1,10.8-17.2,25.3-17.2,40.8c0,23.6,14.3,44.4,35.9,53v59.9 c0,36.5-32,66.1-71.2,66.1c-39.2,0-71.2-29.7-71.2-66.1v-6.8c20.7-4.6,39.6-15.9,53.5-32.2c15.2-17.8,23.5-40.4,23.5-63.7V195.3 c0-6.3-4.4-11.8-10.6-13.1l-44.8-10c-7.3-1.6-14.5,3-16,10.2l-3.3,15.1c-1.6,7.3,3,14.5,10.2,16l22.1,4.9V300 c0,30.9-24.8,56.3-55.3,56.6c-0.2,0-0.4,0-0.6,0c-14.7,0-28.6-5.7-39.1-16.1c-10.7-10.6-16.6-24.7-16.6-39.7v-82.4l22.1-4.9 c3.5-0.8,6.6-2.9,8.5-5.9c1.9-3,2.5-6.6,1.8-10.2l-3.3-15.1c-0.8-3.5-2.8-6.5-5.8-8.4c-3.1-2-6.7-2.6-10.2-1.8l-44.7,9.9 c-6.1,1.3-10.6,6.9-10.6,13.2v105.6c0,23.3,8.4,45.9,23.5,63.7c13.9,16.3,32.8,27.6,53.5,32.2v6.8c0,59.8,51,108.5,113.6,108.5 s113.6-48.7,113.6-108.5v-59.9c21.5-8.5,35.7-29.1,35.9-52.6C512.8,260,487.8,234.2,456.8,233.4z M455.5,305.3 c-8.1,0-14.8-6.6-14.8-14.8c0-8.1,6.6-14.8,14.8-14.8c8.1,0,14.8,6.6,14.8,14.8C470.2,298.7,463.6,305.3,455.5,305.3z"
}));

var SvgListStethoscope = function SvgListStethoscope(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgListStethoscope, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/list-stethoscope.a7408d21.svg";
export { ForwardRef as ReactComponent };